import { useEffect, useState } from 'react'

export default function PWAUpdateNotifier() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const handler = (event) => {
      const { updateSW } = event.detail || {}
      // Auto-refresh without user interaction
      setVisible(true)
      // Activate the waiting service worker before reloading
      if (updateSW) {
        updateSW(true)
      }
    }
    window.addEventListener('pwa:need-refresh', handler)
    return () => window.removeEventListener('pwa:need-refresh', handler)
  }, [])

  if (!visible) return null

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm rounded-2xl border border-gray-200 bg-white shadow-xl p-4">
      <p className="text-sm font-semibold text-gray-900">Updated to the latest version</p>
      <p className="text-xs text-gray-600 mt-1">
        The app refreshed automatically to keep you on the newest build.
      </p>
      <div className="mt-3 flex justify-end">
        <button
          onClick={() => setVisible(false)}
          className="px-3 py-1.5 rounded-full border border-gray-200 text-xs font-semibold text-gray-700 hover:bg-gray-50"
        >
          Dismiss
        </button>
      </div>
    </div>
  )
}
